import { render, staticRenderFns } from "./DocumentDataTable.vue?vue&type=template&id=370c92bc"
import script from "./DocumentDataTable.vue?vue&type=script&lang=js"
export * from "./DocumentDataTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentDataTable.vue?vue&type=style&index=0&id=370c92bc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports